import React from "react";

export default function Shifts() {
  return (
    <div className="content-layout">
      <img src="https://i.imgur.com/9icE0Rj.png" alt="Shifts Page" />
    </div>
  );
}
